var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/Sort.ts";
import * as t from 'io-ts';
export var SortOrder = t.union([t.literal('asc'), t.literal('desc')], 'SortOrder');
export var SortBy = t.literal('name');